export function initAudioPlayer() {
  document.querySelectorAll("[data-audio-player]").forEach((player) => {
    const audio = player.querySelector("[data-audio]");
    const playBtn = player.querySelector("[data-play]");
    const rewindBtn = player.querySelector("[data-rewind]");
    const forwardBtn = player.querySelector("[data-forward]");
    const speedBtn = player.querySelector("[data-speed]");
    const progress = player.querySelector("[data-progress]");
    const currentTimeEl = player.querySelector(".js-audio-time-current");
    const durationEl = player.querySelector(".js-audio-duration");
    const collapse = player.querySelector("[data-collapse]");
    const expand = player.querySelector("[data-expand]");

    const COLLAPSED = "collapsed";

    const SKIP_SECONDS = 15;
    const SPEEDS = [1, 1.25, 1.5, 2];
    let speedIndex = 0;

    // --- helpers
    const formatTime = (seconds) => {
      const m = Math.floor(seconds / 60);
      const s = Math.floor(seconds % 60);
      return `${m}:${s.toString().padStart(2, "0")}`;
    };

    function updateProgress(current, duration) {
      const percent = (current / duration) * 100;
      progress.value = percent;
      progress.style.setProperty("--played", `${percent}%`);
    }

    // --- metadata loaded
    audio.addEventListener("loadedmetadata", () => {
      durationEl.textContent = formatTime(audio.duration);
    });

    // --- play / pause
    playBtn.addEventListener("click", () => {
      if (audio.paused) {
        audio.play();
        playBtn.classList.add("is-playing");
      } else {
        audio.pause();
        playBtn.classList.remove("is-playing");
      }
    });

    audio.addEventListener("ended", () => {
      playBtn.classList.remove("is-playing");
      audio.currentTime = 0;
    });

    // --- time update
    audio.addEventListener("timeupdate", () => {
      currentTimeEl.textContent = formatTime(audio.currentTime);
      progress.value = (audio.currentTime / audio.duration) * 100 || 0;
      updateProgress(audio.currentTime, audio.duration);
    });

    // --- seek
    progress.addEventListener("input", () => {
      audio.currentTime = (progress.value / 100) * audio.duration;
    });

    // --- rewind / forward
    rewindBtn.addEventListener("click", () => {
      audio.currentTime = Math.max(0, audio.currentTime - SKIP_SECONDS);
    });

    forwardBtn.addEventListener("click", () => {
      audio.currentTime = Math.min(
        audio.duration,
        audio.currentTime + SKIP_SECONDS,
      );
    });

    // --- speed
    speedBtn.addEventListener("click", () => {
      speedIndex = (speedIndex + 1) % SPEEDS.length;
      audio.playbackRate = SPEEDS[speedIndex];
      speedBtn.textContent = `x${SPEEDS[speedIndex]}`;
    });

    // -- collapse
    collapse.addEventListener("click", () => {
      player.classList.add(COLLAPSED);
    });

    expand.addEventListener("click", () => {
      player.classList.remove(COLLAPSED);
    });
  });
}
